import { service } from '../../../../helpers/http' 

export const ActionGetSystemAlertMessages = ({ dispatch }, payload) => { 
    return service({
        module: 'systemAlertMessage',
        action: 'getSystemAlertMessages',
        payload: payload
    })
}

export const ActionPostSystemAlertMessages = ({ dispatch }, payload) => {

    return service({
        module: 'systemAlertMessage',
        action: 'postSystemAlertMessages',
        payload: payload
    })
    
}

export const ActionPutSystemAlertMessages = ({ dispatch }, payload) => {

    return service({
        module: 'systemAlertMessage',
        action: 'putSystemAlertMessages',
        payload: payload
    })
    
}

export const ActionDeleteSystemAlertMessages = ({ dispatch }, payload) => {

    return service({
        module: 'systemAlertMessage',
        action: 'deleteSystemAlertMessages',
        payload: payload
    })
    
}
